import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=3247cc06&scoped=true&lang=pug&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=3247cc06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247cc06",
  null
  
)

component.options.__file = "NotFound.vue"
export default component.exports